import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ANNOUNCEMENTS_REQUEST,
  CREATE_ANNOUNCEMENT_REQUEST,
} from './announcementTypes';
import {
  fetchAnnouncementsSuccess,
  fetchAnnouncementsFailure,
  createAnnouncementSuccess,
  createAnnouncementFailure,
} from './announcementActions';
import * as announcementService from './announcementService';

function* fetchAnnouncementsSaga(action) {
  try {
    const response = yield call(announcementService.getAnnouncements, action.payload);
    yield put(fetchAnnouncementsSuccess(response.data));
  } catch (error) {
    yield put(
      fetchAnnouncementsFailure(
        error.response?.data?.message || 'Failed to fetch announcements'
      )
    );
  }
}

function* createAnnouncementSaga(action) {
  try {
    const response = yield call(announcementService.createAnnouncement, action.payload);
    yield put(createAnnouncementSuccess(response.data?.message || 'Announcement created successfully'));
  } catch (error) {
    yield put(
      createAnnouncementFailure(
        error.response?.data?.message || 'Failed to create announcement'
      )
    );
  }
}

export default function* announcementSaga() {
  yield takeLatest(FETCH_ANNOUNCEMENTS_REQUEST, fetchAnnouncementsSaga);
  yield takeLatest(CREATE_ANNOUNCEMENT_REQUEST, createAnnouncementSaga);
}
